<template>
	<div class="all_list">
		<Header2 :searchShow="false" :meauShow="false" :pageTitle="ptitle"></Header2>
		<div class="news_all" v-if="ptype==1">
			<ul class="pnews_ul">
				<li class="pnews_li flex1" v-for="item in dataList" :key="item.id" @click="toDetail(item)">
					<div class="pnews_li_left">
						<p class="li_left_p1 ellip22">{{ item.title }}</p>
						<p class="li_left_p2">{{ item.publishtime }}</p>
					</div>
					<div class="pnews_li_right">
						<img :src="item.image?(staticImg + item.image):noImg" />
					</div>
				</li>
			</ul>
		</div>
		<div class="gg_all" v-if="ptype==2">
			<ul class="gs_ul">
				<li class="gs_li" v-for="(item, index) in dataList" :key="index" @click="toDetail(item)">
					<p class="gs_li_p1">{{ item.title }}</p>
					<p class="gs_li_p2">{{ item.publishtime }}</p>
				</li>
			</ul>
		</div>
		<div class="fenye" v-if="totalPage>0">
			<pagination2 :total-pages="totalPage" :total-num="totalNum" :current-page="currentPage"
				@page-change="handlePageChange" />
		</div>
	</div>
</template>

<script>
import pagination2 from "../../components/pagination2.vue";
export default {
	components: {
		pagination2,
	},
	data() {
		return {
			ptype: '',
			ptitle: '',
			currentPage: 1,
			totalNum: 0,
			totalPage: 0,
			dataList: [],
			staticImg: this.$staticImg + "/",
            noImg:require("@/images/noimg.png")
		}
	},
	created() {
		this.ptype = this.$route.query.type;
		this.ptitle = this.ptype == 1 ? '新闻资讯' : '公告公示';
		this.newslist();
	},
	methods: {
		// 新闻列表
		async newslist() {
			var data2 = {
				typeid: this.ptype == 1 ? 30 : 31,
				page: this.currentPage - 1,
				nums: 10,
			};
			const res = await this.$api.newslist(data2);
			if (res.code == 1) {
				this.totalNum = res.msg;
				this.totalPage = Math.ceil(Number(this.totalNum) / 10);
				if (res.data.length) {
					this.dataList = res.data;
				}
			} else {
				this.dataList = [];
			}
		},
		handlePageChange(newPage) {
			this.currentPage = newPage;
			this.newslist();
		},
		toDetail(item) {
			this.$router.push("/newsDetail?xid=" + item.id + '&typeid=' + item.typeid);
		},
	}
}
</script>

<style lang="scss">
.all_list {
    @font-face {
        font-family: 'SourceHanSans';
        src: url('../../font/SourceHanSansCN-Regular.otf');
    }
    font-family: 'SourceHanSans';
	background-image: url("../../images/bgimg3.png");
	padding: 1.4rem 0.5rem 2.2rem 0.5rem;
	.news_all {
		.pnews_ul {
			.pnews_li {
				padding: 0.4rem 0.6rem;
				border-bottom: 1px solid #dedede;
				.pnews_li_left {
					flex: 1;
					margin-right: 0.67rem;
					.li_left_p1 {
						color: #333;
						font-size: 17px;
						line-height: 1.7;
						margin-bottom: 0.15rem;
						text-align: left;
					}
					.li_left_p2 {
						color: #999;
						font-size: 12px;
						line-height: 1.8;
						text-align: left;
					}
				}
				.pnews_li_right {
					width: 2.667rem;
					flex-shrink: 0;
					img {
						border-radius: 5px;
						width: 100%;
					}
				}
			}
		}
	}
	.gg_all {
		.gs_ul {
			.gs_li {
				padding: 0.4rem 0.6rem;
				border-bottom: 1px solid #dedede;
				.gs_li_p1 {
					color: #333;
					font-size: 17px;
					line-height: 1.7;
					margin-bottom: 0.15rem;
					text-align: left;
				}
				.gs_li_p2 {
					color: #999;
					font-size: 12px;
					line-height: 1.8;
					text-align: left;
				}
			}
		}
	}
	.fenye {
		margin-top: 0.3rem;
		display: flex;
		justify-content: center;
	}
}
</style>